import { Box } from '@chakra-ui/react';
import React, { useContext, useMemo } from 'react';
import { commonStyle } from '../common/styles';
import { LanguageContext } from '../context/LanguageContextProvider';
import { TransitsContext } from '../context/TransitsContextProvider';
import { WindowSizeContext } from '../context/WindowSizeContextProvider';

// transitsの最終更新時刻を表示
const UpdateTime = () => {
  const { language } = useContext(LanguageContext);
  const { lastUpdateTime } = useContext(TransitsContext);
  const { size } = useContext(WindowSizeContext);

  const width = useMemo(() => Math.min(size.w * 0.42, 250), [size.w]);
  const height = useMemo(() => Math.min(size.h * 0.0375, 45), [size.h]);

  return (
    <>
      {lastUpdateTime !== '' && (
        <Box
          w={`${Math.trunc(width)}px`}
          h={`${Math.trunc(height)}px`}
          top={`calc(5% + 4px)`}
          right={'1%'}
          position='fixed'
          color='white'
          bgColor='black'
          fontSize={'clamp(0.875rem, 0.148rem + 3.64vw, 1rem)'}
          border='solid 1px lightgrey'
          borderRadius='6px'
          padding='5px 10px'
          whiteSpace='nowrap'
          sx={{ ...commonStyle.center }}
        >
          {language === 'en'
            ? `as of ${lastUpdateTime}`
            : `${lastUpdateTime}  現在`}
        </Box>
      )}
    </>
  );
};

export default React.memo(UpdateTime);
